import i18next from 'i18next';

i18next.init({
  lng: 'en',
  debug: false,
  ns: ['products'],
  defaultNS: 'products',
});

export default i18next;
